// extracted by mini-css-extract-plugin
export default {"japaneseTableHead":"RSCatalogProductTable_japaneseTableHead__IklIe","multilineText":"RSCatalogProductTable_multilineText__wHxNu","clickable":"RSCatalogProductTable_clickable__KhIQq"};